import * as fromAction from './payment.action';
import { adapter } from './payment.entity';
import { PaymentState } from './payment.state';
import { Action, createReducer, on } from '@ngrx/store';
import { FilterState } from '@shared/models/filter-state';
import {has, isNull} from "lodash";

export const initialState: PaymentState = adapter.getInitialState({
  error: null,
  totalCount: 0,
  filter: new FilterState(),
  paymentIntent: null,
  giftCard: false,
});

const reducer = createReducer(
  initialState,
  on(fromAction.AddPayment, (state, { payment }) => {
    return adapter.addOne(payment, state);
  }),
  on(fromAction.AddPayments, (state, { payments }) => {
    return adapter.setAll(payments, state);
  }),
  on(fromAction.AddTotalCount, (state, { totalCount }) => {
    return adapter.addMany([], { ...state, totalCount: totalCount });
  }),
  on(fromAction.AddError, (state, { error }) => {
    return adapter.addMany([], { ...state, error: error });
  }),
  on(fromAction.AddPaymentFilter, (state, { filter }) => {
    return adapter.addMany([], { ...state, filter: filter });
  }),
  on(fromAction.AddPaymentIntent, (state, { paymentIntent }) => {
    return { ...state, paymentIntent: ((has(paymentIntent,'payIn') || isNull(state.paymentIntent)) ? paymentIntent : {...state.paymentIntent, ...paymentIntent, amount: state.paymentIntent.amount })};
  }),
  on(fromAction.RemovePaymentIntent, (state) => {
    return adapter.addMany([], { ...state, paymentIntent: null });
  }),
  on(fromAction.AddGiftCard, (state, { isValid }) => {
    return adapter.addMany([], { ...state, giftCard: isValid });
  }),
  on(fromAction.RemoveGiftCard, (state) => {
    return adapter.addMany([], { ...state, giftCard: false });
  })
  // on(fromAction.RemovePaymentFilter, (state, { }) => {
  //     return adapter.addMany([], { ...state, filter: new BookingFilter() });
  // }),
);

export function PaymentStoreReducer(state: PaymentState = initialState, action: Action): PaymentState {
  return reducer(state, action);
}
